import { RootState } from "../../../../store";
import { commitmentsSliceSelector } from "../../commitmentsSliceSelector";

export const utilizationAndCoverageDataViewTabSelector = (state: RootState) => {
  const slice = commitmentsSliceSelector(state);

  return slice.coverageAndUtilization.dataViewTab;
};
